import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import classes from './MessageComposer.module.scss';
import Text from '../controls/Text/Text';
import Message from '../../models/Message';
import { addMessage, setQuickResponses } from '../../store/actions/messages';

function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}

const MessageComposer = ({socket}) => {
  const { t } = useTranslation();
  const { sessionId } = useSelector(state => state.general);
  const { mode } = useSelector(state => state.messages);
  const [newMessage, setNewMessage] = useState('');
  const debouncedInputValue = useDebounce(newMessage, 500);
  const [isTypingState, setisTypingState] = useState(false);
  const dispatch = useDispatch()
  const send = () => {
    if (newMessage.trim() !== '') {
      socket.emit("send", {
        message: newMessage,
        session_id: sessionId,
        mode: mode,
        messenger_id: window.sutherland_variables.botId
      });
      const message = {
        "text": newMessage,
        "mode": "user"
      }
      dispatch(addMessage(new Message(message)));
      dispatch(setQuickResponses([]));
      setNewMessage('')
      setisTypingState(false);
    }
  };

  const handleTypingStart = (message) => {
    setNewMessage(message)
    if (!isTypingState) {
      setisTypingState(true);
      socket.emit('is-typing', {})
    }
  };

  const stopTyping = useCallback(() => {
    socket.emit('stop-typing', {})
    setisTypingState(false);
  }, [socket]);

  useEffect(() => {
    if (newMessage === debouncedInputValue && isTypingState && newMessage !== '') {
      stopTyping()
    }
  }, [debouncedInputValue, newMessage, isTypingState, stopTyping]);

  return (
    <div className={classes.MessageComposer} style={window.sutherland_variables.ui.message_composer.container}>
      <div className={classes.textContainer}>
        <Text
          value={newMessage}
          onChange={handleTypingStart}
          placeholder={t('composer.placeholder', 'Type your message here...')}
          onEnter={send}
          name='message'
          maxLength={120}
        />
      </div>

      <button className={classes.Send} onClick={send}>
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
          <path d="M9.71285 16.6211L17.4765 7.53953C17.6229 7.39982 17.33 7.12038 17.1835 7.2601L7.95505 15.0842L4.43945 13.6871C3.85352 13.4775 3.85352 12.709 4.43945 12.3598L19.3075 4.11647C19.9667 3.76718 20.6259 4.25619 20.4794 4.88492L18.2089 18.158C18.0624 18.647 17.5497 18.9264 17.1103 18.7169L13.1552 17.1101L11.0312 19.4853C10.5917 20.0442 9.71285 19.7647 9.71285 19.0662V16.6211Z" fill={window.sutherland_variables.ui.message_composer.icon_colors}
          style={{fill: window.sutherland_variables.ui.message_composer.icon_colors}}
          />
        </svg>
      </button>
    </div>
  );
};

export default MessageComposer;